import { render, staticRenderFns } from "./CardSectionAwardsItem.vue?vue&type=template&id=3e48b6bf"
import script from "./CardSectionAwardsItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CardSectionAwardsItem.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports